import React from 'react';

import { useQuery } from '@apollo/client';

import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { QUERY_STATE } from 'quanta-flows/modules/quote/health';

import {
  Button,
  DataGrid,
  Grid,
  Text,
  useResponsiveParams,
} from 'quanta-ui';
import { updateHealthQuote } from 'quanta-flows/modules/quote/health/state';

export default function QuoteData({ 
  goToStep, 
  genderList,
  productCode,
  productName,
  lobCode,
  quoteNumber,
  setStartStep,
}) {
  let repeatForMobile = 2;
  let repeatForDesktop = 4;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  let { loading, error, data: state } = useQuery(QUERY_STATE);

  if (loading) return <Loading />;
  if (error) return <Error />;

  let { healthQuote, healthPlans } = state;

  const resolveGender = (code) => {
    const gender = genderList.find((gender) => gender.code === code)
      ? genderList.find((gender) => gender.code === code).value
      : code;
    return gender;
  };

  const enableChange = () => {
    let premiumCalculated = 0;
    healthPlans.plans.forEach((plan) => {
      if (plan.premium) premiumCalculated = premiumCalculated + 1;
    });
    return (
      premiumCalculated !== 0 &&
      premiumCalculated === healthPlans.plans.length &&
      healthPlans.plansChanged.length === 0
    );
  };

  let data = [
    {
      title: 'Members',
      grid_data: [
        {
          text: healthQuote.members
            .filter((mem) => mem.selected)
            .map((mem, idx) => (
              <div key={idx}>
                <Text
                  type={
                    repeat === repeatForMobile ? 'label' : 'normal'
                  }
                >
                  {mem.relationship}, {resolveGender(mem.gender)},{' '}
                  {mem.age + ' Years'}
                </Text>
              </div>
            )),
        },
      ],
    },
    {
      title: 'Customer Location',
      grid_data: [
        {
          text: (
            <div>
              {healthQuote.location.city}{' '}
              {healthQuote.location.pincode}
            </div>
          ),
        },
      ],
    },
    {
      title: 'Cover',
      grid_data: [
        {
          text: (
            <div>
              {healthQuote.cover.type}, {healthQuote.cover.tenure}
            </div>
          ),
        },
      ],
    },
    {
      title: '',
      grid_data: [
        {
          label: <Text>&nbsp;</Text>,
          text: !healthQuote.quotationNo ? (
            <div>
              <Button
                flat={true}
                className="w-full md:w-48 max-h-10"
                onClick={(e) => {
                  goToStep(0);
                  setStartStep(0);
                  updateHealthQuote({currentTab: 'members'});
                }}
                disabled={
                  (healthQuote.quotationNo !== null &&
                  // healthQuote.quotationNo !== '') || !enableChange() || healthQuote?.isQuoteSaving
                  healthQuote.quotationNo !== '') || healthQuote?.isQuoteSaving
                }
                iconPre={<FontAwesomeIcon icon={faChevronLeft}/>}
              >
                Change
              </Button>
            </div>
          ) : (
            <Button
              flat={true}
              className="w-full md:w-48 max-h-10"
              onClick={(e) => {
                goToStep(0);
              }}
              iconPre={
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className={`-ml-1 ${
                    repeat === repeatForMobile ? 'mr-2' : ''
                  }`}
                />
              }
            >
              View Members
            </Button>
          ),
        },
      ],
    },
  ];

  return (
    <Grid repeat={repeat} gap={4} className="w-full">
      {data.map((dt, idx) => (
        <DataGrid
          key={idx}
          title={dt.title}
          titleType="title"
          titleSeverity="info"
          gap={1}
          repeat={1}
          data={dt.grid_data}
          textType={repeat === repeatForMobile ? 'label' : 'normal'}
        />
      ))}
    </Grid>
  );
}
